<template>
  <q-btn icon="fa fa-file-pdf" title="Download PDF" flat round @click="download" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    chargeId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    download() {
      window.location.href = `${window.env.MEDIA_URL}/receipts/${this.chargeId}.pdf`;
    },
  },
});
</script>
